import { Controller } from "@hotwired/stimulus"

// Pokazuje pole url/connector/flow w formie webhooka zależnie od wybranego target_kind.
// Wyłącza nieaktywne pola (disabled), żeby ich wartości nie wracały w paramsach.
export default class extends Controller {
  static targets = ["kind", "urlField", "connectorField", "flowField"]
  static values = { kind: String }

  connect() {
    this.apply(this.kindValue || this.kindTarget.value || "url")
  }

  change() {
    this.apply(this.kindTarget.value)
  }

  apply(kind) {
    const map = {
      url: this.hasUrlFieldTarget ? this.urlFieldTarget : null,
      connector: this.hasConnectorFieldTarget ? this.connectorFieldTarget : null,
      flow: this.hasFlowFieldTarget ? this.flowFieldTarget : null,
    }
    Object.entries(map).forEach(([k, el]) => {
      if (el == null) return
      const active = k === kind
      el.classList.toggle("hidden", !active)
      const input = el.querySelector("input, select, textarea")
      if (input) input.disabled = !active
    })
  }
}
